import { Tabs, Tab } from "@heroui/react";
import { useState } from "react";
import DefaultTableLayout from "../DefaultTableLayout/index";

export default function CustomTabs({ tabs = [], defaultTab }) {
  const [selected, setSelected] = useState(defaultTab);
  
  return (
    <div className=" flex w-full flex-col page-wrapper px-6 py-4 bg-white rounded-global h-full">
      <div className="pt-3 h-full">
        <Tabs
          className="pb-1"
          aria-label="Options"
          color="secondary"
          variant="bordered"
          selectedKey={selected}
          onSelectionChange={setSelected}
        >
          {tabs.map((tab) => (
            <Tab
              className="h-[calc(100%_-_42px)]"
              key={tab.key}
              title={
                <div className="flex items-center space-x-2 text-black">
                  {tab.icon}
                  <span>{tab.title}</span>
                </div>
              }
            >
              <div className="m-0 border border-gray-100 rounded-2xl h-full">
                <DefaultTableLayout pageType={tab.key} />
              </div>
            </Tab>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
